import { MutationTree } from 'vuex';
import {
	SET_NONPROFIT_PROFILE_DATA,
	SET_ORG_KEY, SET_OPPORTUNITY,
	SET_COMPANY_ABOUT,
	SET_COMPANY_MISSION,
	ADD_COMPANY_PROGRAM,
	EDIT_COMPANY_PROGRAM,
	ADD_COMPANY_HISTORY,
	EDIT_COMPANY_HISTORY,
	SET_NONPROFIT_CAUSES_DATA,
	SET_SOCIAL_MEDIA,
	SET_FAVORITES,
	SET_GENERAL_NONPROFIT_INFORMATION,
	SET_COMPANY_MEDIA,
	DELETE_COMPANY_HISTORY,
	DELETE_COMPANY_PROGRAM,
	DELETE_MEMBER_POSITION,
	ADD_MEMBER_POSITION,
	DELETE_OPPORTUNITY,
	SET_NONPROFIT_LOCATIONS,
	SET_ALL_PRIORITY_LEVEL,
	SET_SHORTLISTED_OPPORTUNITY,

} from './mutation-types';
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';

import State from './state';
//import { IGeneralInfoOfMember } from '../../../models/interfaces/iGeneralInfoOfMember'
import { INonprofitProfile } from '../../../models/interfaces/nonprofitProfile/iNonprofitProfile';
import { IOpportunity } from '../../../models/interfaces/nonprofitProfile/iOpportunity';
import { IAddEditAboutUsOutput } from '../../../models/interfaces/nonprofitProfile/iAddEditAboutUsOutput';
import { ITextCard } from '../../../models/interfaces/nonprofitProfile/iTextCard';
import { IEditTextCardOutput } from '../../../models/interfaces/nonprofitProfile/iEditTextCardOutput';
import { ICause } from "../../../models/interfaces/iCause";
import { IMemberOrganisationCard } from '../../../models/interfaces/iMemberOrganisationCard';
import { IDeleteMemberCardOutput } from '../../../models/interfaces/iDeleteMemberCardOutput';
import { ILocation } from '../../../models/interfaces/iLocation'
import { NonprofitProfile } from '../../../models/classes/nonprofitProfile/nonprofitProfile';
import { OpportunityTypes } from '../../../components/nonprofitProfile/components/mainPanel/components/opportunity/components/opportunityAddEdit/models/enums/opportunityTypes'
import { PriorityLevel } from '../../../models/classes/nonprofitProfile/priorityLevel';
import { stat } from 'fs';
import { IOpportunities } from '../../../models/interfaces/nonprofitProfile/iOpportunities';
import { Opportunities } from '../../../models/classes/nonprofitProfile/opportunities';

const mutations: MutationTree<State> = {
	[SET_NONPROFIT_PROFILE_DATA](state: State, data: INonprofitProfile): void { 
		
		const nonprofitProfileData: any = Object.keys(data).reduce((acc, key) => {
			const _acc = acc;
			if (data[key] !== undefined)
				_acc[key] = data[key];

			return _acc;
		}, {})

		state.profile = new NonprofitProfile(nonprofitProfileData);
	},

	[SET_ORG_KEY](state: State, orgKey: string): void {

		state.orgKey = orgKey;
	},

	
	[SET_OPPORTUNITY](state: State, opportunity: IOpportunity): void {
		
		switch (opportunity.type.toLocaleLowerCase()) {
			case OpportunityTypes.Board:
				if (!state.profile.opportunities.boardPositions) {
					state.profile.opportunities.boardPositions = [];
				}
				state.profile.opportunities.boardPositions.push(opportunity);
				break;

			case OpportunityTypes.Volunteer:
				if (!state.profile.opportunities.volunteerPrograms) {
					state.profile.opportunities.volunteerPrograms = [];
				}
				state.profile.opportunities.volunteerPrograms.push(opportunity);
				break;

			case OpportunityTypes.Membership:
				if (!state.profile.opportunities.membershipGroups) {
					state.profile.opportunities.membershipGroups = [];
				}
				state.profile.opportunities.membershipGroups.push(opportunity);
				break;
			case OpportunityTypes.Group:
				if (!state.profile.opportunities.groupActivities) {
					state.profile.opportunities.groupActivities = [];
				}
				state.profile.opportunities.groupActivities.push(opportunity);
				break;
			case OpportunityTypes.Sponsorship:
				if (!state.profile.opportunities.sponsorshipOpportunities) {
					state.profile.opportunities.sponsorshipOpportunities = [];
				}
				state.profile.opportunities.sponsorshipOpportunities.push(opportunity);
				break;
		}
	},
	[SET_SHORTLISTED_OPPORTUNITY](state: State, opportunity: IOpportunities): void {
		const opportunities: any = Object.keys(opportunity).reduce((acc, key) => {
			const _acc = acc;
			if (opportunity[key] !== undefined)
				_acc[key] = opportunity[key];

			return _acc;
		}, {})
		state.profile.opportunities = opportunities;
		// state.profile.opportunities = new Opportunities(opportunities.boardPositions, opportunities.membershipGroups, opportunities.groupActivities, opportunities.sponsorshipOpportunities, opportunities.shortlistedOpportunities,opportunities.shortlistedOpportunities);
		// switch (opportunity.type.toLocaleLowerCase()) {
		// 	case OpportunityTypes.Board:
		// 		if (!state.profile.opportunities.boardPositions) {
		// 			state.profile.opportunities.boardPositions = [];
		// 		}
		// 		state.profile.opportunities.boardPositions.push(opportunity);
		// 		break;

		// 	case OpportunityTypes.Volunteer:
		// 		if (!state.profile.opportunities.volunteerPrograms) {
		// 			state.profile.opportunities.volunteerPrograms = [];
		// 		}
		// 		state.profile.opportunities.volunteerPrograms.push(opportunity);
		// 		break;

		// 	case OpportunityTypes.Membership:
		// 		if (!state.profile.opportunities.membershipGroups) {
		// 			state.profile.opportunities.membershipGroups = [];
		// 		}
		// 		state.profile.opportunities.membershipGroups.push(opportunity);
		// 		break;
		// 	case OpportunityTypes.Group:
		// 		if (!state.profile.opportunities.groupActivities) {
		// 			state.profile.opportunities.groupActivities = [];
		// 		}
		// 		state.profile.opportunities.groupActivities.push(opportunity);
		// 		break;
		// 	case OpportunityTypes.Sponsorship:
		// 		if (!state.profile.opportunities.sponsorshipOpportunities) {
		// 			state.profile.opportunities.sponsorshipOpportunities = [];
		// 		}
		// 		state.profile.opportunities.sponsorshipOpportunities.push(opportunity);
		// 		break;
		// }
	},
	[SET_COMPANY_ABOUT](state: State, aboutUs: IAddEditAboutUsOutput): void {
		state.profile.generalInfo.about = aboutUs.about;
	},

	[SET_COMPANY_MISSION](state: State, mission: string): void {
		state.profile.generalInfo.mission = mission;
	},

	[ADD_COMPANY_PROGRAM](state: State, program: ITextCard): void {
		if (!state.profile.programs) {
			state.profile.programs = [];
		}
		state.profile.programs.push(program);
	},

	[EDIT_COMPANY_PROGRAM](state: State, program: IEditTextCardOutput): void {
		state.profile.programs = state.profile.programs.map((el: ITextCard) => {
			if (el.key === program.key) {
				el = program;
			}

			return el;
		});
	},

	[DELETE_COMPANY_PROGRAM](state: State, program: IEditTextCardOutput): void {
		const index = state.profile.programs.findIndex((el: ITextCard) => {
			return el.key === program.key;
		});

		if (index > -1) {
			state.profile.programs.splice(index, 1);
		}
	},

	[ADD_COMPANY_HISTORY](state: State, history: ITextCard): void {
		if (!state.profile.history) {
			state.profile.history = [];
		}
		state.profile.history.push(history);
	},

	[EDIT_COMPANY_HISTORY](state: State, history: IEditTextCardOutput): void {
		state.profile.history = state.profile.history.map((el: ITextCard) => {
			if (el.key === history.key) {
				el = history;
			}

			return el;
		});
	},

	[DELETE_COMPANY_HISTORY](state: State, history: IEditTextCardOutput): void {
		const index = state.profile.history.findIndex((el: ITextCard) => {
			return el.key === history.key;
		});

		if (index > -1) {
			state.profile.history.splice(index, 1);
		}
	},

	[SET_NONPROFIT_CAUSES_DATA](state: State, causes: ICause[]): void {
		//if (data) {
		//	state.profile.causes = data;
		//      }
		// debugger;
		let currentCauses: ICause[] = state.profile.causes;

		if (causes) {
			state.profile.causes = causes;
		}
		else {
			currentCauses.splice(0, currentCauses.length);
		}
	},

	[SET_SOCIAL_MEDIA](state: State, data: any): void {
		if (data) {
			state.profile.socialMedias = data;
		}
	},

	[SET_FAVORITES](state: State, isFan: boolean): void {
		state.profile.isFan = isFan;
	},

	[SET_GENERAL_NONPROFIT_INFORMATION](state: State, data: any): void {
		Object.assign(state.profile.generalInfo, data !== undefined ? data : {});
	},

	[SET_COMPANY_MEDIA](state: State, data: any): void {
		state.profile.media = data;
	},

	[DELETE_MEMBER_POSITION](state: State, data: IDeleteMemberCardOutput): void {
		const type = data.type;
		let positions;

		switch (type) {
			case 'executives':
				positions = state.profile.ourExecutives;
				break;

			case 'staff':
				positions = state.profile.ourStaff;
				break;

			case 'national-govering':
				positions = state.profile.ourNationalGoverningBoard;
				break;

			case 'associate':
				positions = state.profile.ourAssociateBoard;
				break;

			case 'govering':
				positions = state.profile.ourGoverningBoard;
				break;
			case 'advisory':
				positions = state.profile.ourAdvisoryBoard;
				break;

			case 'fans':
				positions = state.profile.fanMembers;
				break;
		}


		const index = positions.findIndex((el: IMemberOrganisationCard) => {
			return el.memberOrgKey === data.memberOrgKey;
		});

		if (index > -1) {
			positions.splice(index, 1);
		}
	},

	[ADD_MEMBER_POSITION](state: State, data: { type: string, members: IMemberOrganisationCard[] }): void {
		const type = data.type;
		let positions: IMemberOrganisationCard[];

		switch (type) {
			case 'Associate Board':
				positions = state.profile.ourAssociateBoard;
				break;

			case 'Governing Board':
				positions = state.profile.ourGoverningBoard;
				break;

			case 'National Govering Board':
				positions = state.profile.ourNationalGoverningBoard;
				break;

			case 'Executive':
				positions = state.profile.ourExecutives;
				break;

			case 'Staff':
				positions = state.profile.ourStaff;
				break;
			case 'Advisory Board Member':
				positions = state.profile.ourAdvisoryBoard;
				break;

		}

		if (!positions) {
			positions = [];
		}

		data.members.map((el: IMemberOrganisationCard) => {
			positions.push(el);
		});
	},

	[DELETE_OPPORTUNITY](state: State, data: { type: string, key: string }): void {
		const type = data.type;
		let opportunities;

		switch (type) {
			case OpportunityTypes.Board:
				opportunities = state.profile.opportunities.boardPositions;
				break;

			case OpportunityTypes.Volunteer:
				opportunities = state.profile.opportunities.volunteerPrograms;
				break;

			case OpportunityTypes.Membership:
				opportunities = state.profile.opportunities.membershipGroups;
				break;

			case OpportunityTypes.Group:
				opportunities = state.profile.opportunities.groupActivities;
				break;
			
			case OpportunityTypes.Sponsorship:
				opportunities = state.profile.opportunities.sponsorshipOpportunities;
				break;
		}


		const index = opportunities.findIndex((el: IOpportunity) => {
			return el.key === data.key;
		});

		if (index > -1) {
			opportunities.splice(index, 1);
		}
	},

	[SET_NONPROFIT_LOCATIONS](state: State, data: ILocation[]) {
		state.profile.locations = data;
	},

	[SET_ALL_PRIORITY_LEVEL](state: State, data: PriorityLevel[]): void {
		state.priorityLevelData = data;
	},

};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/nonprofit/mutations.ts